// extracted by mini-css-extract-plugin
export default {"modal":"FullscreenModal_modal__qPOgK","close":"FullscreenModal_close__oWQyG","content":"FullscreenModal_content__mAjdI"};